
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class UpdateIndicator extends Vue {
  @Prop({ default: false })
  public isLoading!: boolean;

  // 🚩 Flag for whether the label for up-to-date data is shown
  private showUpToDateLabel: boolean = false;

  /**
   * 👂 Listener for changes in the loading flag
   */
  @Watch("isLoading")
  private onIsLoadingChanged(val: boolean, oldVal: boolean) {
    if (!val && oldVal) {
      this.showUpToDateLabel = true;
      setTimeout(() => (this.showUpToDateLabel = false), 1500);
    }
  }
}
